import PropTypes from 'prop-types';

export const RouterLocation = PropTypes.shape({
  pathname: PropTypes.string.isRequired,
});
export const RouterMatch = PropTypes.shape({
  params: PropTypes.shape({}).isRequired,
});
export const RouterHistory = PropTypes.shape({
  push: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
});
